import { TERMS_OF_SERVICE_2024_09_05 } from "./2024-09-05";

export * from "./types";
export { TERMS_OF_SERVICE_2024_09_05 };

/**
 * The Terms of Service version shown to users and recorded when they accept.
 *
 * To publish new terms, add a new `versions/<effective-date>.ts` file and point this at it.
 * Never edit a published version file: it's the record of what users agreed to.
 */
export const CURRENT_TERMS_OF_SERVICE = TERMS_OF_SERVICE_2024_09_05;
